// stitches.config.js
import { createStyled } from '@stitches/react'

export const { styled, css } = createStyled({
  prefix: '',
  tokens: {},
  breakpoints: {},
  utils: {}
})
